import {
  Box,
  Card,
  CardActionArea,
  Checkbox,
  Tooltip,
  alpha,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const ToggleCard = ({
  selected,
  children,
  onClick,
  button = true,
  disabled = false,
  showCheckbox = false,
  title = '',
  sx,
  'aria-label': ariaLabel,
  ...props
}) => {
  return (
    <Tooltip title={title}>
      <Card
        sx={theme => ({
          boxShadow: 'none',
          border: '1px solid',
          borderColor: 'text.secondary',
          ...(selected
            ? {
                border: '2px solid',
                borderColor: 'primary.main',
                backgroundColor: alpha(
                  theme.palette.primary.main,
                  theme.palette.action.selectedOpacity
                ),
              }
            : {}),
          flexShrink: 0,
          ...sx,
        })}
        {...props}
      >
        {showCheckbox && (
          <Box
            sx={{
              position: 'absolute',
              top: 2,
              left: 2,
              zIndex: 1,
            }}
          >
            <Checkbox
              checked={selected}
              disabled={disabled}
              disableRipple
              sx={{padding: 0}}
              onClick={onClick}
            />
          </Box>
        )}
        {button ? (
          <CardActionArea
            disabled={disabled}
            onClick={onClick}
            sx={{height: '100%'}}
            aria-label={ariaLabel}
          >
            {children}
          </CardActionArea>
        ) : (
          children
        )}
      </Card>
    </Tooltip>
  );
};

ToggleCard.propTypes = {
  selected: PropTypes.bool,
  children: PropTypes.node,
  onClick: PropTypes.func,
  button: PropTypes.bool,
  disabled: PropTypes.bool,
  showCheckbox: PropTypes.bool,
  title: PropTypes.string,
  sx: PropTypes.object,
  'aria-label': PropTypes.string,
};

export default ToggleCard;
